export const coursePlayer = {
    state: {
        coursePlayer: [],
        videos: [],
        materials: [],
        userStats: [],
        currentVideo: [],
        playVideo: false,
        totalVideos: 0,
        courseCompleted: false,
        test: [],
        ppts: [],
        totalPpts: 0,
        currentPpt:[],
        playPpt: false,
        scorm: [],
        currentScorm:[],
        playScorm: false,
        emailHeaderLogo: '',
        emailFooterLogo: '',
    },
    mutations: {
        SET_CoursePlayer(state, coursePlayer) {
            state.coursePlayer = coursePlayer;
        },
        SET_Videos(state, course) {
            let watched = course.enrolled.data.watched.data.map(x => {
                return x.asset.data.id
            });
            let vids = course.assets.data.map(x => {                
                if(x.asset_type == 'video'){
                x.watched = watched.includes(x.id) ? true : false;
                return x;
                }
            });
            state.videos = vids;
        },
        SET_CoursePreviewVideos(state, course) {
            if(!course.enrolled) {
                course.enrolled = course.assets.data;
            }
            // let watched = course.enrolled.data.watched.data.map(x => {
            //     return x.asset.data.id
            // });
            let vids = course.videos.data.map(x => {
                //x.watched = watched.includes(x.id) ? true : false;
                return x;
            });
            state.videos = vids;
        },
        SET_Materials(state, materials) {
            //state.materials = materials;
            if(materials.enrolled) {
                let watched = materials.enrolled.data.watched.data.map(x => {
                    return  x.asset.data.asset_type == 'external link'  ? x.asset.data.id  : x.assetdocument.data.id
                });
                
                let mids = materials.assets.data.map(x => {
                    if( x.asset_type == 'document' || x.asset_type == 'external link' ){
                        x.watched = watched.includes(x.id) ? true : false;
                        return x;
                    }
                });
                state.materials = mids;
            } else {
                state.materials = materials.documents.data;
            }
        },
        SET_Test(state, test) {
            state.test = test;
        },
        SET_UserStats(state, userStats) {
            state.userStats = userStats;
        },
        SET_CurrentVideo(state, currentVideo) {
            state.currentVideo = currentVideo;
        },
        SET_PlayVideo(state, playVideo) {
            state.playVideo = playVideo;
        },
        SET_TotalVideos(state, videos) {
            state.totalVideos = videos.length;
        },
        SET_Ppts(state, course) {
            if(course.hasOwnProperty('ppts')) {
                state.ppts = course.ppts.data;
            }
        },
        SET_CurrentPpt(state, currentPpt) {
            state.currentPpt = currentPpt;
        },
        SET_TotalPpts(state, ppts) {
            state.totalPpts = ppts.length;
        },
        SET_PlayPpt(state, playPpt) {
            state.playPpt = playPpt;
        },
        SET_Scorm(state, materials) {
            if(materials && materials.enrolled && materials.enrolled.data) {
                let watched = materials.enrolled.data.watched.data.map(x => {
                    return x.assetdocument.data.id
                });

                let mids = materials.assets.data.map(x => {
                    if(x.asset_type == 'scorm'){
                    x.watched = watched.includes(x.id) ? true : false;
                    return x;
                    }
                });

                state.scorm = mids;
                
            } else {
                state.scorm = materials.scorm.data;
            }
        },
        SET_CurrentScorm(state, currentScorm) {
            state.currentScorm = currentScorm;
        },
        setPlayScorm(state, bool) {
            state.playScorm = bool;
        },
        SET_EmailHeaderlogo(state, file) {
            state.emailHeaderLogo = file;
        },
        SET_EmailFooterlogo(state, file) {
            state.emailFooterLogo = file;
        }
    },
    actions: {
        setCoursePlayer: ({ commit, state }, course) => {
            commit('SET_CoursePlayer', course)
            commit('SET_Materials', course)
            commit('SET_CurrentVideo', course.videos.data[0])
            commit('SET_UserStats', course.enrolled.data)
            commit('SET_Videos', course)
            commit('SET_TotalVideos', course.videos.data)
            if(course.hasOwnProperty('ppts')) {
                commit('SET_CurrentPpt', course.ppts.data[0])
                commit('SET_TotalPpts', course.ppts.data)
                commit('SET_Ppts', course.ppts.data)
            }

            if(course.hasOwnProperty('test')) {
                commit('SET_Test', course.test.data)
            }
            if(course.hasOwnProperty('scorm')) {
                commit('SET_Scorm', course)
                // commit('SET_CurrentScorm', course.scorm.data[0])
            }

            return state.coursePlayer
        },
        setCoursePreviewCoursePlayer: ({ commit, state }, course) => {
            commit('SET_CoursePlayer', course)
            commit('SET_Materials', course)
            commit('SET_CurrentVideo', course.videos.data[0])
            //commit('SET_UserStats', course.enrolled.data)
            commit('SET_CoursePreviewVideos', course)
            commit('SET_TotalVideos', course.videos.data)

            if(course.hasOwnProperty('test')) {
                commit('SET_Test', course.test.data)
            }
            if(course.hasOwnProperty('scorm')) {
                commit('SET_Scorm', course)
                commit('SET_CurrentScorm', course.scorm.data[0])
            }

            return state.coursePlayer
        },
        setMaterials: ({ commit, state }, materials) => {
            commit('SET_Materials', materials)
            return state.materials
        },
        setTest: ({ commit, state }, test) => {
            commit('SET_Test', test)
            return state.test
        },
        setVideos: ({ commit, state }, course) => {
            commit('SET_Videos', course)
            return state.videos
        },
        setUserStats: ({ commit, state }, userStats) => {
            commit('SET_UserStats', userStats)
            return state.userStats
        },
        setCurrentVideo: ({ commit, state }, currentVideo) => {
            commit('SET_CurrentVideo', currentVideo)
            return state.currentVideo
        },
        setPlayVideo: ({ commit, state }, playVideo) => {
            commit('SET_PlayVideo', playVideo)
            return state.playVideo
        },
        setCurrentPpt: ({ commit, state }, currentPpt) => {
            commit('SET_CurrentPpt', currentPpt)
            return state.currentPpt
        },
        setPpts: ({ commit, state }, course) => {
            commit('SET_Ppts', course)
            return state.ppts
        },
        setPlayPpt: ({ commit, state }, PlayPpt) => {
            commit('SET_PlayPpt', PlayPpt)
            return state.PlayPpt
        },
        setScorm: ({ commit, state }, scorm) => {
            commit('SET_Scorm', scorm)
            return state.scorm
        },
        setCurrentScorm: ({ commit, state }, currentScorm) => {
            commit('SET_CurrentScorm', currentScorm)
            return state.currentScorm
        },
        setEmailHeaderLogo: ({ commit, state }, file) => {
            commit('SET_EmailHeaderlogo', file)
            return state.emailHeaderLogo
        },
        setEmailFooterLogo: ({ commit, state }, file) => {
            commit('SET_EmailFooterlogo', file)
            return state.emailFooterLogo
        },
    },
    getters: {
        coursePlayer: (state) => {
            return state.coursePlayer
        },
        videos: (state) => {
            return state.videos
        },
        materials: (state) => {
            return state.materials
        },
        userStats: (state) => {
            return state.userStats
        },
        currentVideo: (state) => {
            return state.currentVideo
        },
        totalVideos: (state) => {
            return state.totalVideos
        },
        courseCompleted: (state) => {
            return state.courseCompleted
        },
        playVideo: (state) => {
            return state.playVideo
        },
        test: (state) => {
            return state.test
        },
        currentPpt: (state) => {
            return state.currentPpt
        },
        totalPpts: (state) => {
            return state.totalPpts
        },
        ppts: (state) => {
            return state.ppts
        },
        playPpt: (state) => {
            return state.playPpt
        },
        currentScorm: (state) => {
            return state.currentScorm
        },
        playScorm: (state) => {
            return state.playScorm
        },
        emailHeaderLogo: (state) => {
            return state.emailHeaderLogo
        },
        emailFooterLogo: (state) => {
            return state.emailFooterLogo
        }
        
    }
};